var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPackageTransfersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "10px",
    height: "9px",
    viewBox: "0 0 10 9",
    enableBackground: "new 0 0 10 9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#373E43",
    d: "M8.5,8h-7v0.5C1.5,8.775,1.276,9,1,9H0.5C0.224,9,0,8.775,0,8.5V4l1.256-3.351C1.403,0.259,1.776,0,2.193,0 h5.614c0.418,0,0.791,0.259,0.938,0.649L10,4v4.5C10,8.775,9.775,9,9.5,9H9C8.725,9,8.5,8.775,8.5,8.5V8z M1.068,4h7.864L7.807,1 H2.193L1.068,4z M2.25,6.5C2.664,6.5,3,6.164,3,5.75S2.664,5,2.25,5S1.5,5.336,1.5,5.75S1.836,6.5,2.25,6.5z M7.75,6.5 c0.414,0,0.75-0.336,0.75-0.75S8.164,5,7.75,5S7,5.336,7,5.75S7.336,6.5,7.75,6.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageTransfersIcon);
export default __webpack_public_path__ + "static/media/package_transfers_icon.200327fd7f36c1da67c4b05714a706fc.svg";
export { ForwardRef as ReactComponent };